exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-estimate-qna[data-v-22ade270]{margin-bottom:12px}.lp-estimate-qna[data-v-22ade270]:last-child{margin-bottom:0}.form-item[data-v-22ade270]{overflow-y:auto;height:250px;border:1px solid #ddd;padding:20px}", ""]);

// exports
